import { BetOrderStatus } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const betOrderStatusDictionary = createSimpleDictionary([
    { id: BetOrderStatus.Open, name: 'dictionaries.open' },
    { id: BetOrderStatus.Closed, name: 'dictionaries.closed' },
    { id: BetOrderStatus.Closing, name: 'dictionaries.closing' },
]);
